module.exports = __webpack_public_path__ + "saira-regular-webfont.0b97a14f48f403afecea.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-regular-webfont.eot
// module id = ../../../../../src/assets/fonts/saira-regular-webfont.eot
// module chunks = styles